// Environment configuration helper
// Supports both build-time env vars (process.env) and runtime env vars (window._env_)

declare global {
  interface Window {
    _env_?: {
      REACT_APP_API_BASE_URL?: string;
      REACT_APP_OIDC_AUTHORITY?: string;
      REACT_APP_OIDC_CLIENT_ID?: string;
    };
  }
}

/**
 * Get environment variable with fallback to runtime config (for Docker)
 */
function getEnvVar(key: string, defaultValue: string): string {
  // First check runtime config (from Docker)
  const runtimeValue = window._env_?.[key as keyof typeof window._env_];
  if (runtimeValue !== undefined && runtimeValue !== null && runtimeValue !== '') {
    return runtimeValue;
  }

  // Then check build-time environment variables
  const buildValue = process.env[key];
  if (buildValue && buildValue !== '') {
    return buildValue;
  }

  // Fall back to default
  return defaultValue;
}

export const env = {
  API_BASE_URL: getEnvVar('REACT_APP_API_BASE_URL', 'http://localhost:5097/api'),
  OIDC_AUTHORITY: getEnvVar('REACT_APP_OIDC_AUTHORITY', 'https://bitlab.id.bitlab.ch'),
  OIDC_CLIENT_ID: getEnvVar('REACT_APP_OIDC_CLIENT_ID', 'spa_d4157f37649f4b6b8e0397fa0f70c0b9'),
};
